import React, { useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import UserIcon from '@BUP/assets/Icons/user_icon.svg'
import PageLayout from '@BUP/components/Layout/Page'
import TitleDashboard from '@BUP/components/Generics/TitleDashboard'
import BupSpinner from '@BUP/components/Loading/Spinner'
import AlertComponent from '@BUP/components/Generics/Alert'
import PreferencesForm from '@BUP/components/CourseAssignment/PreferencesForm'
import { useGetCurrentPreferencesPeriod } from '@BUP/hooks/CourseAssignment/useGetCurrentPreferencesPeriod'
import { useGetMyPreferences } from '@BUP/hooks/CourseAssignment/useGetMyPreferences'
import { useSavePreferences } from '@BUP/hooks/CourseAssignment/useSavePreferences'

const MAX_SELECTION = 5

const CourseAssignmentPreferencesPage = () => {
  const [t] = useTranslation('translation', { keyPrefix: 'pages.data.courseAssignmentPreferences' })

  const {
    isLoading: isLoadingPeriod,
    period,
    classmates,
    error: errorPeriod
  } = useGetCurrentPreferencesPeriod()

  const {
    isLoading: isLoadingPreferences,
    classmateEnrollmentIds,
    error: errorPreferences
  } = useGetMyPreferences({ enabled: !!period })

  const {
    mutateAsync: savePreferences,
    isPending: isSubmitting,
    error: errorSaving
  } = useSavePreferences()

  const handleSubmit = useCallback((selectedClassmateIds) => {
    savePreferences(selectedClassmateIds)
  }, [savePreferences])

  const renderContent = () => {
    if (isLoadingPeriod || (period && isLoadingPreferences)) {
      return <BupSpinner size='large' />
    }

    if (errorPeriod || errorPreferences) {
      return (
        <AlertComponent
          type='error'
          messageKey='common.resources.course-assignment.actions.read.failure'
          error={errorPeriod || errorPreferences}
        />
      )
    }

    if (!period || period.status !== 'open') {
      return <AlertComponent type='info' message={t('noPeriodOpen')} />
    }

    return (
      <>
        <p>{t('description')}</p>
        <PreferencesForm
          classmatesOptions={classmates}
          initialSelection={classmateEnrollmentIds}
          maxSelection={MAX_SELECTION}
          isPeriodOpen={period.status === 'open'}
          onSubmit={handleSubmit}
          isSubmitting={isSubmitting}
        />
        {errorSaving && (
          <AlertComponent
            type='error'
            messageKey='common.resources.course-assignment.actions.update.failure'
            error={errorSaving}
          />
        )}
      </>
    )
  }

  return (
    <PageLayout>
      <>
        <TitleDashboard icon={UserIcon} text={t('title')} />
        {renderContent()}
      </>
    </PageLayout>
  )
}

export default CourseAssignmentPreferencesPage
